/* eslint-disable max-len */
import { INTL_IDS } from './messages';

export const CHANGE_STATEMENTS_FILTER = 'app/Documents/CHANGE_STATEMENTS_FILTER';

export const DOWNLOAD_DOCUMENT = 'app/Documents/DOWNLOAD_DOCUMENT';
export const DOWNLOAD_DOCUMENT_FAILURE = 'app/Documents/DOWNLOAD_DOCUMENT_FAILURE';

export const FETCH_DOCUMENTS_HOME = 'app/Documents/FETCH_DOCUMENTS_HOME';
export const FETCH_DOCUMENTS_HOME_FAILURE = 'app/Documents/FETCH_DOCUMENTS_HOME_FAILURE';
export const FETCH_DOCUMENTS_HOME_SUCCESS = 'app/Documents/FETCH_DOCUMENTS_HOME_SUCCESS';

export const FETCH_STATEMENT = 'app/Documents/FETCH_STATEMENT';
export const FETCH_STATEMENT_CANCELLED = 'app/Documents/FETCH_STATEMENT_CANCELLED';
export const FETCH_STATEMENT_FAILURE = 'app/Documents/FETCH_STATEMENT_FAILURE';
export const FETCH_STATEMENT_SUCCESS = 'app/Documents/FETCH_STATEMENT_SUCCESS';

export const FETCH_STATEMENTS = 'app/Documents/FETCH_STATEMENTS';
export const FETCH_STATEMENTS_FAILURE = 'app/Documents/FETCH_STATEMENTS_FAILURE';
export const FETCH_STATEMENTS_SUCCESS = 'app/Documents/FETCH_STATEMENTS_SUCCESS';

export const REFRESH_STATEMENTS_URL = 'app/Documents/REFRESH_STATEMENTS_URL';

export const RESET_ERRORS = 'app/Documents/RESET_ERRORS';

export const RESET_STATEMENTS_STATE = 'app/Documents/RESET_STATEMENTS_STATE';

export const SET_HOME_LOADING_STEP = 'app/Documents/SET_HOME_LOADING_STEP';

export const SET_STATEMENTS_FILE = 'app/Documents/SET_STATEMENTS_FILE';
export const SET_STATEMENTS_PAGES_RENDERED = 'app/Documents/SET_STATEMENTS_PAGES_RENDERED';

export const TOGGLE_STATEMENTS_DRAWER = 'app/Documents/TOGGLE_STATEMENTS_DRAWER';

export const UPDATE_REFETCH_STATUS = 'app/Documents/UPDATE_REFETCH_STATUS';

/* eslint-disable max-len */
export const COUPON_ACCOUNT_MESSAGE = 'Your account is set up for payment coupons instead of monthly billing statements. If you are looking for a verification of mortgage, please contact us at ';
export const DOWNLOAD_ERROR_MESSAGE = 'We are unable to download your document.\nPlease try again later or call customer service.';
export const FETCH_ERROR_MESSAGE = 'An error has occurred while trying to retrieve your documents. If this issue persists, please call customer service at';
export const NO_STATEMENTS_MESSAGE = 'There are no statements. View, schedule, and pay your loan with a few simple steps.';
export const STATEMENT_BLOCKED_MESSAGE = 'You will need to enable pop-ups in your browser for this site in order to view this content.';

export const FILTER_ID_ALLTYPES = 'allTypes';
export const FILTER_ID_MONTHLY = 'monthly';
export const FILTER_ID_ESCROW = 'escrow';
export const FILTER_ID_YEAREND = 'yearEnd';

export const FILTER_TAB_LIST_DESKTOP = [
  {
    filterId: FILTER_ID_ALLTYPES,
    filterLabel: 'All Types',
  },
  {
    filterId: FILTER_ID_MONTHLY,
    filterLabel: 'Monthly Statements',
  },
  {
    filterId: FILTER_ID_ESCROW,
    filterLabel: 'Escrow Statements',
  },
  {
    filterId: FILTER_ID_YEAREND,
    filterLabel: 'Year-End Statements',
  },
];

export const FILTER_TAB_LIST_MOBILE = [
  {
    filterId: FILTER_ID_ALLTYPES,
    filterLabel: 'All Types',
  },
  {
    filterId: FILTER_ID_MONTHLY,
    filterLabel: 'Monthly',
  },
  {
    filterId: FILTER_ID_ESCROW,
    filterLabel: 'Escrow',
  },
  {
    filterId: FILTER_ID_YEAREND,
    filterLabel: 'Year-End',
  },
];

export const STATEMENTS_DICTIONARY = {
  [FILTER_ID_ALLTYPES]: { emptyDataMessage: 'There are no Statements.' },
  [FILTER_ID_ESCROW]: { emptyDataMessage: 'There are no Escrow Statements.' },
  [FILTER_ID_MONTHLY]: { emptyDataMessage: 'There are no Monthly Statements.' },
  [FILTER_ID_YEAREND]: { emptyDataMessage: 'There are no Year-End Statements.' },
};

/* eslint-disable sort-keys */
export const BILLING_STATEMENT_TYPES = {
  'All Types': FILTER_ID_ALLTYPES,
  'Mortgage Billing Statement': FILTER_ID_MONTHLY,
  'Escrow Analysis Statement': FILTER_ID_ESCROW,
  1098: FILTER_ID_YEAREND,
};

export const COUPON_MOBILE_MESSAGE = {
  accountText: 'Your account is set up for payment coupons instead of monthly billing statements.',
  customerContactTextOne: 'If you are looking for a verification of',
  customerContactTextTwo: 'mortgage, please contact us at ',
};

export const DOCUMENTS_HOME_CARD_LOOKUP = [
  {
    ariaLabel: INTL_IDS.HOME_CARD_STATEMENTS_ARIALABEL,
    bodyText: INTL_IDS.HOME_CARD_STATEMENTS_BODYTEXT,
    dataName: 'numStatements',
    desktopPath: '/documents/statements',
    emptyLabel: INTL_IDS.HOME_CARD_STATEMENTS_EMPTYLABEL,
    heading: INTL_IDS.HOME_CARD_STATEMENTS_HEADING,
    mobilePath: 'Statements',
    nonemptyLabel: INTL_IDS.HOME_CARD_STATEMENTS_NONEMPTYLABEL,
  },
  {
    ariaLabel: INTL_IDS.HOME_CARD_PAYOFF_ARIALABEL,
    bodyText: INTL_IDS.HOME_CARD_PAYOFF_BODYTEXT,
    dataName: 'numPayoff',
    desktopPath: '/payoff',
    emptyLabel: INTL_IDS.HOME_CARD_PAYOFF_EMPTYLABEL,
    heading: INTL_IDS.HOME_CARD_PAYOFF_HEADING,
    mobilePath: 'Payoff',
    nonemptyLabel: INTL_IDS.HOME_CARD_PAYOFF_NONEMPTYLABEL,
  },
  {
    ariaLabel: INTL_IDS.HOME_CARD_FORMSANDRESOURCES_ARIALABEL,
    bodyText: INTL_IDS.HOME_CARD_FORMSANDRESOURCES_BODYTEXT,
    dataName: 'numGeneral',
    desktopPath: '/documents/general',
    emptyLabel: INTL_IDS.HOME_CARD_FORMSANDRESOURCES_EMPTYLABEL,
    heading: INTL_IDS.HOME_CARD_FORMSANDRESOURCES_HEADING,
    mobilePath: 'GeneralDocs',
    nonemptyLabel: INTL_IDS.HOME_CARD_FORMSANDRESOURCES_NONEMPTYLABEL,
  },
];

export const GENERAL_DOCS_LIST = [
  {
    documentId: 1,
    documentName: 'Change of Address Form',
    documentUrl: 'https://dudhzjl76se9h.cloudfront.net/docs/Change_of_Mailing_Address_Form.pdf',
  },
  {
    documentId: 2,
    documentName: 'Third Party Authorization Form',
    documentUrl: 'https://dudhzjl76se9h.cloudfront.net/docs/Third_Party_Authorization_Form.pdf',
  },
  {
    documentId: 3,
    documentName: 'Loss Draft Overview',
    documentUrl: 'https://dudhzjl76se9h.cloudfront.net/docs/Loss+Draft+Initial+Overview.pdf',
  },
  {
    documentId: 4,
    documentName: 'Lien Waiver Form',
    documentUrl: 'https://dudhzjl76se9h.cloudfront.net/docs/Lien+Waiver+Form.pdf',
  },
];
